import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Vehicle } from '@quorum/models/xs-resource';
import { ApiService } from '@quorum/api';
import { Address, Associate } from '@quorum/models/xs-resource';

@Component({
  selector: 'svc-create-appointment',
  templateUrl: './create-appointment.component.html',
  styleUrls: ['./create-appointment.component.scss'],
})
export class CreateAppointmentComponent implements OnInit {
  vehicle: Vehicle = new Vehicle();
  associate: Associate = new Associate();
  address: Address = new Address();
  constructor(private route: ActivatedRoute, private apiService: ApiService) {}

  ngOnInit() {
    let params: any;
    if (this.route.snapshot.queryParams.vehicleId) {
      this.apiService
        .get(`/v/1/vehicles/vehicles/${this.route.snapshot.queryParams.vehicleId}`)
        .subscribe((vehicle) => {
          this.vehicle = vehicle;
          console.log(this.vehicle);
        });
    }
    if (this.route.snapshot.queryParams.associateId) {
      this.apiService
        .get(`/v/1/associates/associates/${this.route.snapshot.queryParams.associateId}`)
        .subscribe((associate) => {
          this.associate = associate;
          console.log(this.associate);
        });
      this.apiService
        .get(`/v/1/associates/associates/${this.route.snapshot.queryParams.associateId}/addresses`)
        .subscribe((addresses) => {
          this.address = addresses[0];
          console.log(this.address);
        });
    }
  }
}
